import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';
import { customerId } from 'common/helpers/tokenHelper';

export const listCustomerAddresses = (queryString) => {
  if (queryString) {
    return axios.get(
      `${getV2RootUrl()}/customer/${customerId()}/address?${queryString}`,
      axiosHeaderV2()
    );
  }
  return axios.get(
    `${getV2RootUrl()}/customer/${customerId()}/address`,
    axiosHeaderV2()
  );
};

export const addCustomerAddress = (customerAddress) =>
  axios.post(
    `${getV2RootUrl()}/customer/${customerId()}/address/`,
    customerAddress,
    axiosHeaderV2()
  );

export const editCustomerAddress = (customerAddressId, customerAddress) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId()}/address/${customerAddressId}`,
    customerAddress,
    axiosHeaderV2()
  );

export const deleteCustomerAddress = (customerAddressId) =>
  axios.delete(
    `${getV2RootUrl()}/customer/${customerId()}/address/${customerAddressId}`,
    axiosHeaderV2()
  );
